// startup
// Load entry module
__webpack_require__("./src/scripts-1r/index.js");
// This entry module used 'exports' so it can't be inlined
__webpack_require__("./src/scripts-1r/style.scss");
